import { List } from '../objects/list';
import { Category } from '../objects/destinationCategory';
import { Column } from '../objects/column';

export const MOVE_DOWN_COLUMN = 'DESTINATION_CATEGORY_MOVE_DOWN_COLUMN';
export const MOVE_UP_COLUMN = 'DESTINATION_CATEGORY_MOVE_UP_COLUMN';
export const RESET_ADD_CATEGORY = 'DESTINATION_CATEGORY_RESET_ADD_CATEGORY';
export const RESET_FILTERS = 'DESTINATION_CATEGORY_RESET_FILTERS';
export const SET_CATEGORY = 'DESTINATION_CATEGORY_SET_CATEGORY';
export const SET_CATEGORY_DELETE = 'DESTINATION_CATEGORY_SET_CATEGORY_DELETE';
export const SET_EDIT_STEP = 'DESTINATION_CATEGORY_SET_EDIT_STEP';
export const SET_EXPORT_TYPE = 'DESTINATION_CATEGORY_SET_EXPORT_TYPE';
export const SET_LIMIT = 'DESTINATION_CATEGORY_SET_LIMIT';
export const SET_LIST = 'DESTINATION_CATEGORY_SET_LIST';
export const SET_ORDER_BY = 'DESTINATION_CATEGORY_SET_ORDER_BY';
export const SET_PAGE = 'DESTINATION_CATEGORY_SET_PAGE';
export const SET_RUNNING = 'DESTINATION_CATEGORY_SET_RUNNING';
export const SET_SEARCH = 'DESTINATION_CATEGORY_SET_SEARCH';
export const TOGGLE_CANCEL_MODAL = 'DESTINATION_CATEGORY_TOGGLE_CANCEL_MODAL';
export const TOGGLE_COLUMN = 'DESTINATION_CATEGORY_TOGGLE_COLUMN';
export const TOGGLE_CREATE = 'DESTINATION_CATEGORY_TOGGLE_CREATE';
export const TOGGLE_EXPORT = 'DESTINATION_CATEGORY_TOGGLE_EXPORT';
export const TOGGLE_EXPORT_FULL = 'DESTINATION_CATEGORY_TOGGLE_EXPORT_FULL';
export const TOGGLE_FILTERS = 'DESTINATION_CATEGORY_TOGGLE_FILTERS';
export const TOGGLE_REFRESH = 'DESTINATION_CATEGORY_TOGGLE_REFRESH';
export const UPDATE_DESTINATION_CATEGORIES_NAME_LOCALE = 'DESTINATION_CATEGORY_UPDATE_DESTINATION_CATEGORIES_NAME_LOCALE';
export const UPDATE_FILTER_CREATED_DATE_GTE = 'DESTINATION_CATEGORY_UPDATE_FILTER_CREATED_DATE_GTE';
export const UPDATE_FILTER_CREATED_DATE_LTE = 'DESTINATION_CATEGORY_UPDATE_FILTER_CREATED_DATE_LTE';
export const UPDATE_FILTER_CREATOR = 'DESTINATION_CATEGORY_UPDATE_FILTER_CREATOR';
export const UPDATE_FILTER_LAST_AUTHOR = 'DESTINATION_CATEGORY_UPDATE_FILTER_LAST_AUTHOR';
export const UPDATE_FILTER_MODIFIED_DATE_GTE = 'DESTINATION_CATEGORY_UPDATE_FILTER_MODIFIED_DATE_GTE';
export const UPDATE_FILTER_MODIFIED_DATE_LTE = 'DESTINATION_CATEGORY_UPDATE_FILTER_MODIFIED_DATE_LTE';
export const UPDATE_FILTER_PERIOD = 'DESTINATION_CATEGORY_UPDATE_FILTER_PERIOD';
export const UPDATE_FILTER_PERIOD_TYPE = 'DESTINATION_CATEGORY_UPDATE_FILTER_PERIOD_TYPE';
export const SET_COLUMNS = 'DESTINATION_CATEGORY_SET_COLUMNS';


interface SetColumnsAction {
    type: typeof SET_COLUMNS,
    payload: Column[]
}
interface MoveDownColumnAction {
    type: typeof MOVE_DOWN_COLUMN,
    payload: number
}

interface MoveUpColumnAction {
    type: typeof MOVE_UP_COLUMN,
    payload: number
}
interface ResetAddCategoryAction {
    type: typeof RESET_ADD_CATEGORY
}

interface ResetFiltersAction {
    type: typeof RESET_FILTERS
}

interface SetCategoryAction {
    type: typeof SET_CATEGORY,
    payload: Category
}

interface SetCategoryDeleteAction {
    type: typeof SET_CATEGORY_DELETE,
    payload: null | false | Category
}

interface SetEditStepAction {
    type: typeof SET_EDIT_STEP,
    payload: string | null
}

interface SetExportTypeAction {
    type: typeof SET_EXPORT_TYPE,
    payload: 'CSV' | 'PDF'
}

interface SetLimitAction {
    type: typeof SET_LIMIT,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: List
}

interface SetOrderByAction {
    type: typeof SET_ORDER_BY,
    payload: string
}

interface SetPageAction {
    type: typeof SET_PAGE,
    payload: number
}

interface SetRunningAction {
    type: typeof SET_RUNNING,
    payload: boolean
}

interface SetSearchAction {
    type: typeof SET_SEARCH,
    payload: string
}

interface ToggleCancelModalAction {
    type: typeof TOGGLE_CANCEL_MODAL
}

interface ToggleColumnAction {
    type: typeof TOGGLE_COLUMN,
    payload: number
}

interface ToggleExportAction {
    type: typeof TOGGLE_EXPORT,
    payload: boolean
}

interface ToggleExportFullAction {
    type: typeof TOGGLE_EXPORT_FULL
}

interface ToggleFiltersAction {
    type: typeof TOGGLE_FILTERS
}

interface ToggleNewAction {
    type: typeof TOGGLE_CREATE
}

interface ToggleRefreshAction {
    type: typeof TOGGLE_REFRESH
}

interface UpdateDestinationCategoriesNameLocaleAction {
    type: typeof UPDATE_DESTINATION_CATEGORIES_NAME_LOCALE,
    payload: {
        value: string,
        id: number,
    }
}

interface UpdateFilterCreatedDateGteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterCreatedDateLteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterCreatorAction {
    type: typeof UPDATE_FILTER_CREATOR,
    payload: string
}

interface UpdateFilterLastAuthorAction {
    type: typeof UPDATE_FILTER_LAST_AUTHOR,
    payload: string
}

interface UpdateFilterModifiedDateGteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterModifiedDateLteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterPeriodAction {
    type: typeof UPDATE_FILTER_PERIOD,
    payload: 'CREATION' | 'MODIFICATION'
}

interface UpdateFilterPeriodTypeAction {
    type: typeof UPDATE_FILTER_PERIOD_TYPE,
    payload: number
}
export type DestinationCategoryActionTypes =
    SetColumnsAction |
    MoveDownColumnAction |
    MoveUpColumnAction |
    ResetAddCategoryAction |
    ResetFiltersAction |
    SetCategoryAction |
    SetCategoryDeleteAction |
    SetEditStepAction |
    SetExportTypeAction |
    SetLimitAction |
    SetListAction |
    SetOrderByAction |
    SetPageAction |
    SetRunningAction |
    SetSearchAction |
    ToggleCancelModalAction |
    ToggleColumnAction |
    ToggleExportAction |
    ToggleExportFullAction |
    ToggleFiltersAction |
    ToggleNewAction |
    ToggleRefreshAction |
    UpdateDestinationCategoriesNameLocaleAction |
    UpdateFilterCreatedDateGteAction |
    UpdateFilterCreatedDateLteAction |
    UpdateFilterCreatorAction |
    UpdateFilterLastAuthorAction |
    UpdateFilterModifiedDateGteAction |
    UpdateFilterModifiedDateLteAction |
    UpdateFilterPeriodAction |
    UpdateFilterPeriodTypeAction;